import { render } from "./BaseRadioButton.vue?vue&type=template&id=a70fe906&scoped=true"
import script from "./BaseRadioButton.vue?vue&type=script&lang=js"
export * from "./BaseRadioButton.vue?vue&type=script&lang=js"

import "./BaseRadioButton.vue?vue&type=style&index=0&id=a70fe906&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a70fe906"]])

export default __exports__